// Generated file : do not modify
export enum RubriqueCategorys
{
  NONE = 0,
  CONTRAT,
  BRUT,
  NET_FRAIS,
  ACOMPTE_AVANCE,
  NET_AVANTAGE,
  BRUT_AVANTAGE
};

export enum RubriqueTypes
{
  NONE = 0,
  HEURES,
  NOMBRE,
  MONTANT,
  DATE,
  MENSUEL
};

import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Rubriques de paie
export class RubriquePaie {
  // Rubrique
  public rubriqueId: number;
  // Base
  public rbase: number;
  // Quantité
  public quantite: number;
  // Dates
  public date: Date;

  constructor() {
    this.rubriqueId = 0;
    this.rbase = 0;
    this.quantite = 0;
    this.date = new Date(1901,1,1,0,0,0,0);
  }
}

export class VariablePaie {
  // Rubrique
  public rubriqueId: number;
  // Quantité
  public quantite: number;
  // Dates
  public date: Date;
  // Faire figurer au contrat
  public showOnContract: boolean;

  constructor() {
    this.rubriqueId = 0;
    this.quantite = 0;
    this.date = new Date(1901,1,1,0,0,0,0);
    this.showOnContract = false;
  }
}

export class BaseSalarie {
  // Rubrique
  public rubriqueId: number;
  // Base
  public rbase: number;
  // Minimum légal
  public minimum: number;

  constructor() {
    this.rubriqueId = 0;
    this.rbase = 0;
    this.minimum = 0;
  }
}

export default class Rubrique  {
  // Identifiant unique
  public id: number;
  // Code
  public code: string;
  // Libellé
  public label: string;
  // Code paie
  public codePaie: string;
  // Libellé court
  public minLabel: string;
  // Catégorie
  public category: RubriqueCategorys;
  // Minimum (€)
  public minimum: number;
  // Type
  public type: RubriqueTypes;
  // Valeur soustraite
  public negatif: boolean;
  // Hors paie
  public prePayed: boolean;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.code = '';
    this.label = '';
    this.codePaie = '';
    this.minLabel = '';
    this.category = RubriqueCategorys.NONE;
    this.minimum = 0;
    this.type = RubriqueTypes.NONE;
    this.negatif = false;
    this.prePayed = false;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Rubrique): Rubrique {
    const newRubrique: Rubrique = new Rubrique();
    newRubrique.id = obj.id;
    newRubrique.code = obj.code;
    newRubrique.label = obj.label;
    newRubrique.codePaie = obj.codePaie;
    newRubrique.minLabel = obj.minLabel;
    newRubrique.category = obj.category;
    newRubrique.minimum = obj.minimum;
    newRubrique.type = obj.type;
    newRubrique.negatif = obj.negatif;
    newRubrique.prePayed = obj.prePayed;
    newRubrique.createId = obj.createId;
    newRubrique.failed = obj.failed;
    newRubrique.canUpdate = obj.canUpdate;
    newRubrique.canDelete = obj.canDelete;
    newRubrique.display = obj.display;
    newRubrique.notifDefType = obj.notifDefType;
    return newRubrique;
  }

  public toJsonRubrique (): string {
    const json = {
      code: this.code,
      label: this.label,
      codePaie: this.codePaie,
      minLabel: this.minLabel,
      category: this.category,
      minimum: this.minimum,
      type: this.type,
      negatif: this.negatif,
      prePayed: this.prePayed,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromRubrique (obj: Rubrique): void {
    this.id = obj.id;
    this.code = obj.code;
    this.label = obj.label;
    this.codePaie = obj.codePaie;
    this.minLabel = obj.minLabel;
    this.category = obj.category;
    this.minimum = obj.minimum;
    this.type = obj.type;
    this.negatif = obj.negatif;
    this.prePayed = obj.prePayed;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareRubrique (value: Rubrique): boolean {
    return (this.toJsonRubrique() == value.toJsonRubrique());
  }

  public cloneRubrique (): Rubrique {
    return Rubrique.fromJson(this);
  }

  public createForStoreRubrique (): Promise<Rubrique> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/rubriques/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromRubrique(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreRubrique (): Promise<Rubrique> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/rubriques/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromRubrique(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreRubrique (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/rubriques/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/rubriques/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Rubriques/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Rubrique.fromJson(listData.reccords[0] as Rubrique);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Rubrique> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Rubriques/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Rubrique.fromJson(listData.reccords[0] as Rubrique);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(rubriques: Rubrique[]) {
  }
}
